import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const HelpReplyBanner = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [first, setFirst] = useState(null);

  const load = useCallback(() => {
    if (!user) { setFirst(null); return; }
    axios.get(`${API_URL}/api/help-requests/mine`, { withCredentials: true })
      .then((r) => setFirst((r.data?.requests || []).find((x) => x.unread > 0) || null))
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    load();
    const t = setInterval(load, 90000);
    window.addEventListener('help-replies-seen', load);
    return () => { clearInterval(t); window.removeEventListener('help-replies-seen', load); };
  }, [load]);

  if (!first || pathname.startsWith('/play/')) return null;
  return (
    <Link
      to={`/play/${first.puzzle_id}`}
      className="flex items-center justify-center gap-2 px-4 py-2 text-xs sm:text-sm bg-[#8B5A3C] text-[#FFF3E4] hover:bg-[#7A4E33] transition-colors"
      data-testid="help-reply-global-banner"
    >
      <LifeBuoy className="w-4 h-4 shrink-0" />
      <span>
        <span className="font-semibold">The community replied</span> to your Level {first.level} help request.
        <span className="underline ml-1">Back to my grid</span>
      </span>
    </Link>
  );
};
